const getDeviceScreen = () => {
  let size = window.innerWidth > 768 ? "tablet" : "mobile";
  return size;
};

module.exports = {
  getDeviceScreen: getDeviceScreen,
};
